module.exports = __webpack_public_path__ + "img/livinglab-logo-light-bg.7c9a13cc.svg";